import * as Yup from "yup";
import i18n from "../i18n";
import { BLACKLIST_TYPES, DOC_TYPE_ID } from "../constants/common";

export const AddBlacklistVisitorSchema = Yup.object({
  blacklistType: Yup.number(),
  // .required(
  //   i18n.language === "en"
  //     ? "Blacklist type is required"
  //     : "نوع القائمة السوداء مطلوب"
  // ),

  idType: Yup.number().when("blacklistType", {
    is: BLACKLIST_TYPES.PERSON,
    then: (schema) =>
      schema.required(
        i18n.language === "en" ? "ID Type is required." : "نوع الهوية مطلوب."
      ),
    otherwise: (schema) => schema.notRequired(),
  }),

  eid: Yup.string()
    .nullable()
    .when("idType", {
      is: (idType: DOC_TYPE_ID) => idType === DOC_TYPE_ID.NATIONAL_ID,
      then: (schema) =>
        schema
          .matches(
            /^$|\d{1,10}$/,
            i18n.language === "en"
              ? "Enter a valid National ID."
              : "أدخل رقم هوية وطنية صالحاً."
          )
          .required(
            i18n.language === "en"
              ? "National ID is required."
              : "يجب تقديم الهوية الوطنية."
          ),
      otherwise: (schema) => schema.notRequired(),
    }),

  passportNumber: Yup.string()
    .nullable()
    .when("idType", {
      is: (idType: DOC_TYPE_ID) => idType === DOC_TYPE_ID.PASSPORT,
      then: (schema) =>
        schema
          .matches(
            /^(?!^0+$)[a-zA-Z0-9]{3,20}$/,
            i18n.language === "en"
              ? "Enter a valid passport number."
              : "أدخل رقم جواز سفر صالحاً."
          )
          .required(
            i18n.language === "en"
              ? "Passport number is required."
              : "رقم جواز السفر مطلوب."
          ),
      otherwise: (schema) => schema.notRequired(),
    }),

  iqama: Yup.string()
    .nullable()
    .when("idType", {
      is: (idType: DOC_TYPE_ID) => idType === DOC_TYPE_ID.IQAMA,
      then: (schema) =>
        schema
          .matches(
            /^$|\d{1,10}$/,
            i18n.language === "en"
              ? "Enter a valid iqama number."
              : "أدخل رقم إقامة صالح."
          )
          .required(
            i18n.language === "en" ? "Iqama is required." : "يشترط الإقامة."
          ),
      otherwise: (schema) => schema.notRequired(),
    }),

  visaNumber: Yup.string()
    .nullable()
    .when("idType", {
      is: (idType: DOC_TYPE_ID) => idType === DOC_TYPE_ID.VISA,
      then: (schema) =>
        schema
          .matches(
            /^[A-Z0-9][A-Z0-9\s-]{5,13}$/,
            i18n.language === "en"
              ? "Enter a valid visa number"
              : "أدخل رقم تأشيرة صالحًا"
          )
          .required(
            i18n.language === "en"
              ? "Visa number is required."
              : "رقم التأشيرة مطلوب."
          ),
      otherwise: (schema) => schema.notRequired(),
    }),

  //    iqama: Yup.string().matches(
  //   /^$|\d{1,10}$/,
  //   i18n.language === "en"
  //     ? "Enter a valid iqama number."
  //     : "أدخل رقم إقامة صالح."
  // ),
  // visaNumber: Yup.string().matches(
  //   /^[A-Z0-9][A-Z0-9\s-]{5,13}$/,
  //   i18n.language === "en"
  //     ? "Enter a valid visa number"
  //     : "أدخل رقم تأشيرة صالحًا"
  // ),

  // companyName: Yup.string().when("blacklistType", {
  //   is: (val: BLACKLIST_TYPES) => val === BLACKLIST_TYPES.COMPANY,
  //   then: (schema) =>
  //     schema.required(
  //       i18n.language === "en"
  //         ? "Company name is required."
  //         : "اسم الشركة مطلوب."
  //     ),
  //   otherwise: (schema) => schema.notRequired(),
  // }),

  // nationality: Yup.string().when("blacklistType", {
  //   is: BLACKLIST_TYPES.NATIONALITY,
  //   then: (schema) => schema.required(),
  //   otherwise: (schema) => schema.notRequired(),
  // }),

  reason: Yup.string().required(),
});
